<template>
  <HeadlineComponent>Veranstaltung bearbeiten</HeadlineComponent>
  <Form
    class="form-horizontal"
    @submit="onSubmit"
    :initialValues="event"
    v-slot="{ setFieldValue }"
    v-if="loaded"
  >
    <EventForm :event="event" :setFieldValue="setFieldValue"></EventForm>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading"
        >Speichern</LoadingButton
      >
    </div>
  </Form>
</template>

<script>
import eventService from "@/services/event.service.js";
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import moment from "moment";
import { Form } from "vee-validate";
import EventForm from "@/components/EventForm.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default {
  name: "UpdateEventView",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Form, HeadlineComponent, EventForm, LoadingButton },
  data() {
    return {
      event: {
        latitude: 51.16,
        longitude: 10.45,
        unset_end_date: false,
        unset_ticket_send_date: false,
      },
      loaded: false,
      loading: false,
    };
  },
  async beforeMount() {
    try {
      let response = await eventService.get(this.$route.params.event);
      this.setEvent(response.data);
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
    this.loaded = true;
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    setEvent(event) {
      this.event = event;
      this.event.start_date = moment(this.event.start_date).format(
        "YYYY-MM-DDTHH:mm"
      );
      this.event.ticket_send_date = moment(this.event.ticket_send_date).format(
        "YYYY-MM-DDTHH:mm"
      );
      this.event.end_date = moment(this.event.end_date).format(
        "YYYY-MM-DDTHH:mm"
      );
    },
    async onSubmit(form, actions) {
      this.loading = true;
      try {
        let e = JSON.parse(JSON.stringify(form));
        e.latitude = Math.round((e.latitude % 180) * 1000000) / 1000000;
        e.longitude = Math.round((e.longitude % 360) * 1000000) / 1000000;
        e.start_date = moment(e.start_date, "YYYY-MM-DDTHH:mm").format();
        const tsd = moment(e.ticket_send_date, "YYYY-MM-DDTHH:mm");
        e.ticket_send_date = tsd.isValid() ? tsd.format() : null;
        const ed = moment(e.end_date, "YYYY-MM-DDTHH:mm");
        e.end_date = ed.isValid() ? ed.format() : null;
        e.min_required_shifts = Number(e.min_required_shifts);
        e.end_date = moment(e.end_date, "YYYY-MM-DDTHH:mm").format();
        const response = await eventService.update(this.event.id, e);
        this.setEvent(response.data);
        window.scrollTo(0, 0);
        this.addAlert("success", "Event erfolgreich bearbeitet.");
        this.loaded = false;

        window.setTimeout(() => {
          this.loaded = true;
        });
      } catch (e) {
        if (e) {
          if (e.response && e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
            this.loading = false;
            return;
          }
          console.log(e);
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
